import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders } from '../../../../../Containers/Config/index.js';
import { UPDATE_EVENT_RULE, UPDATE_EVENT_RULE_SUCCESS, UPDATE_EVENT_RULE_ERROR } from '../../../actionType';
import apiCall from '../../../apiCall';
import cogoToast from 'cogo-toast';
import { Constant } from '../../../../../Containers/Helpers/constant.js';

function* updateEventRule({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/event-rules`,
      method: 'PUT',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        ...payload.urlParam,
      },
      data: payload.data,
    });

    if (response.status === 200) {
      cogoToast.success(`Updated Successfully`);
      yield put({
        type: UPDATE_EVENT_RULE_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: UPDATE_EVENT_RULE_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: UPDATE_EVENT_RULE_ERROR, payload: error });
  }
}

export function* watchUpdateEventRule() {
  yield takeEvery(UPDATE_EVENT_RULE, updateEventRule);
}

function* updateEventRuleSaga() {
  yield all([fork(watchUpdateEventRule)]);
}

export default updateEventRuleSaga;
